import { Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import ContactUs from './ContactUs'

const HavingTrouble = () => {
  const [openConatctUs, setOpenContactUs] = useState<boolean>(false)
  const handleCloseContactUs = () => {
    setOpenContactUs(false)
  }
  const handleOpenContactUs = () => {
    setOpenContactUs(true)
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleOpenContactUs()
    }
  }

  return (
    <Stack
      direction="row"
      spacing={0.5}
      useFlexGap
      flexWrap="wrap"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Typography component="span" variant="utility10" color={(theme) => theme.palette.colors?.disabledIconColor}>
        Having trouble logging in? Please
      </Typography>
      <Typography
        variant="h3"
        component="span"
        color={(theme) => theme.palette.colors?.blue2}
        sx={{ cursor: 'pointer' }}
        onClick={handleOpenContactUs}
        onKeyDown={handleKeyDown}
        tabIndex={0}
      >
        contact us.
      </Typography>
      {openConatctUs && <ContactUs open={openConatctUs} handleClose={handleCloseContactUs} />}
    </Stack>
  )
}

export default HavingTrouble
